module.exports = __webpack_public_path__ + "img/symbol-hash-right.4ec11b80.png";